<template>
    <div v-if="date" class="d-flex align-center refresh-widget d-print-none">
      <span style="color: #616161; text-decoration: underline; cursor: pointer;" @click="$emit('refresh')">
        {{ $t('wkt.admin.common.updated-at', [formatLongDateTime(date, true)]) }}
      </span>
      <v-icon small class="ml-2" @click="$emit('refresh')">autorenew</v-icon>
    </div>
</template>

<script>
import BaseModule from './BaseModule';

export default {
	name: 'RefreshWidget',
	mixins: [BaseModule],
	data () {
		return {
			date: null,
		}
	},
	methods: {
		update() {
			this.date = new Date();
		}
	},
}
</script>